import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    width: '100%',
    minHeight: '100vh',
  },
  sub: {
    width: '100%',
    padding: '20px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    textTransform: 'uppercase',
    background: '#FF7A01',
    color: '#fff',
    marginBottom: '20px',

    '& a': {
      color: '#fff',
    },

    '& div': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      padding: '12px 0',
    },
  },
  company: {
    fontSize: '0.675rem',
    fontWeight: 600,
    marginBottom: '4px',
  },
  category: {
    fontSize: '0.575rem',
    fontWeight: 600,
  },
  extract: {
    padding: '0 20px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    textTransform: 'uppercase',
    marginBottom: '20px',

    '& span': {
      fontSize: '1rem',
      fontWeight: 500,
    },
  },
  totalDebit: {
    color: 'red',
  },
  totalCredit: {
    color: 'green',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
  },
  item: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    background: '#fff',
    border: '1px solid #c4c4c4',
    borderRadius: '10px',
    marginBottom: '20px',
  },
  itemInfo: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '0.675rem',
  },
  itemInfoValues: {
    marginTop: '10px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontWeight: 500,
  },
});

export default useStyles;
